import React from 'react';
import {connect} from 'react-redux';
import {CHAIN, BRACELET} from "../../constants";
import Letter from '../lib/Letter';
import {StraightChain, Loop} from "../lib/Chain";

class StandardPreview extends React.Component {
    render() {
        return (
            <>
                {this.props.input && this.props.input.length > 0 &&
                    <StraightChain chain={this.props.chain} width={300}/>
                }

                {this.props.input.map((letter, index) => <Letter key={index} letter={letter}/>)}

                {this.props.input && this.props.input.length > 0 &&
                    <StraightChain chain={this.props.chain} width={300}/>
                }
            </>
        );
    }
}


class SpacedPreview extends React.Component {
    getSpacing(input) {
        switch (input.length) {
            case 0: return 0;
            case 1: return 0;
            case 2: return 150;
            case 3: return 120;
            case 4: return 90;
            case 5: return 75;
            case 6: return 65;
            case 7: return 55;
            case 8: return 50;
            case 9: return 45;
            case 10: return 40;
        }
    }

    render() {
        let input = this.props.input;
        let spacing = this.getSpacing(input);

        return (
            <>
                {input && input.length > 0 &&
                    <StraightChain chain={this.props.chain} width={300}/>
                }

                {input.map((letter, index) =>
                    <React.Fragment key={index}>
                        {this.props.chain === CHAIN.BUTCH &&
                            <div className="customizer-preview__letter-w-loop">
                                <Loop/>
                                <Letter letter={letter}/>
                            </div>
                        }

                        {this.props.chain !== CHAIN.BUTCH &&
                            <Letter letter={letter}/>
                        }

                        {index !== input.length - 1 &&
                            <StraightChain width={spacing} chain={this.props.chain}/>
                        }
                    </React.Fragment>
                 )}

                {input && input.length > 0 &&
                    <StraightChain chain={this.props.chain} width={300}/>
                }
            </>
        );
    }
}

class SidewaysPreview extends React.Component {
    getSpacing(input) {
        switch (input.length) {
            case 0: return 0;
            case 1: return 0;
            case 2: return 150;
            case 3: return 120;
            case 4: return 80;
            case 5: return 55;
            case 6: return 45;
            case 7: return 35;
            case 8: return 30;
            case 9: return 25;
            case 10: return 20;
        }
    }

    render() {
        let input = this.props.input;
        let spacing = this.getSpacing(input);

        return (
            <>
                {input && input.length > 0 &&
                    <StraightChain chain={this.props.chain} width={300}/>
                }

                {input.map((letter, index) =>
                    <React.Fragment key={index}>
                        <Letter letter={letter}/>
                        {index !== input.length - 1 &&
                            <StraightChain width={spacing} chain={this.props.chain}/>
                        }
                    </React.Fragment>
                )}

                {input && input.length > 0 &&
                    <StraightChain chain={this.props.chain} width={300}/>
                }
            </>
        );
    }
}

class PreviewContainer extends React.Component {
    render() {
        let className = '';
        className += `customizer-preview `;
        className += `customizer-preview--bracelet `;
        className += `customizer-preview--${this.props.orientation.description.toLowerCase()} `;
        className += `${this.props.color.description.toLowerCase().replace(' ', '-')} `;

        return (
            <div className={className}>
                <div className="customizer-preview__container">
                    {this.props.orientation === BRACELET.STANDARD &&
                        <StandardPreview input={this.props.input} color={this.props.color} chain={this.props.chain}/>
                    }
                    {this.props.orientation === BRACELET.SPACED &&
                        <SpacedPreview input={this.props.input} color={this.props.color} chain={this.props.chain}/>
                    }
                    {this.props.orientation === BRACELET.SIDEWAYS &&
                        <SidewaysPreview input={this.props.input} color={this.props.color} chain={this.props.chain}/>
                    }
                    {this.props.input && this.props.input.length === 0 &&
                        <div>type something</div>
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        input: state.input.split(''),
        orientation: state.braceletOrientation,
        color: state.goldColor,
        chain: state.chain,
    }
};

export default connect(mapStateToProps)(PreviewContainer);
